import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import QCheck from 'components/QCheck';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  progressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '4px',
  },
  centerWrapper: {
    height: 415,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
}));

function BillScoutLoadingView({ loading }: { loading: boolean }) {
  const { classes } = useStyles();
  return (
    <div className={classes.centerWrapper} id='waiterSize'>
      <Typography variant='titleMedium'>{loading ? 'Hang Tight!' : 'All Right!'}</Typography>
      <Typography variant='bodyRegular' color='textSecondary'>
        {loading ? "We're processing your transactions." : "We've got your data."}
      </Typography>
      <div className={classes.progressWrapper}>
        {loading ? <CircularProgress size={80} style={{ margin: 20 }} /> : <QCheck style={{ margin: 38 }} size={44} />}
        <Typography variant='bodyRegular' color='textSecondary'>
          {loading ? 'This should only take a few moments.' : "Let's continue"}
        </Typography>
      </div>
    </div>
  );
}

export default BillScoutLoadingView;
